export default __webpack_public_path__ + "static/media/grid6.0d77ca40.png";